// frontend/src/mobile/platform.js
export function rilevaPiattaforma(ua) {
  const s = (ua || '').toLowerCase();
  if (/iphone|ipad|ipod/.test(s)) return 'ios';
  if (/android/.test(s)) return 'android';
  return 'altro';
}
